import React from 'react';
import { Tooltip } from 'antd';
import type { TooltipProps } from 'antd'
import cn from 'classnames';
import Iconfont from '@base/lib/Iconfont';
import styles from './index.module.less';

type IProps = {
    icon?: React.ReactNode;
} & TooltipProps

const ThemeTooltip: React.FC<IProps> = (props) => {

    const {
        title = <span className={styles.title}>prompt text</span>,
        overlayInnerStyle,
        icon,
        ...tooltipReset
    } = props

    return (
        <Tooltip
            placement="top"
            title={title}
            color={'white'}
            overlayInnerStyle={{
                color: '#666',
                padding: '12px',
                ...overlayInnerStyle
            }}
            getPopupContainer={trigger => trigger.parentElement as HTMLDivElement}
            {...tooltipReset}
        >
            <Iconfont className={cn('icon-help pointer', styles['default-icon'])}/>
        </Tooltip>
    )
}

export default React.memo(ThemeTooltip);
